// src/components/editor/ComponentLibrary.jsx
import React from 'react';
import { Type, Image, Square } from 'lucide-react';

const componentTypes = [
  { type: 'title', icon: Type, label: '标题' },
  { type: 'text', icon: Type, label: '文本' },
  { type: 'image', icon: Image, label: '图片' },
  { type: 'button', icon: Square, label: '按钮' }
];

export default function ComponentLibrary({ onAdd }) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <Square className="w-5 h-5 mr-2 text-blue-600" />
        组件库
      </h2>
      <div className="space-y-3">
        {componentTypes.map((comp) => {
          const Icon = comp.icon;
          return (
            <button
              key={comp.type}
              onClick={() => onAdd(comp.type)}
              className="w-full flex items-center space-x-3 p-3 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors group"
            >
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                <Icon className="w-5 h-5 text-blue-600" />
              </div>
              <span className="text-gray-700 font-medium">{comp.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}